import { render, staticRenderFns } from "./affiliatePartner.vue?vue&type=template&id=9c4c2698&"
import script from "./affiliatePartner.vue?vue&type=script&lang=js&"
export * from "./affiliatePartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports